import React, {useEffect, useState} from 'react';

import Question1 from './Question1';
import Question2 from './Question2';
import Question3 from './Question3';
import Question4 from './Question4';
import Question5 from './Question5';
import Question6 from './Question6';

const Feedback = () => {
    const [question, setQuestion] = useState(0);

    useEffect(() => {
        // scroll back to top page
        window.scrollTo(0, 0);
    })

    const nextQuestion = (num) => {
        setQuestion(num);
    }

    let questionComponent;

    switch (question) {
        case 0:
            questionComponent = <Question1 nextQuestion={nextQuestion}/>;
            break;
        case 1:
            questionComponent = <Question2 nextQuestion={nextQuestion}/>;
            break;
        case 2:
            questionComponent = <Question3 nextQuestion={nextQuestion}/>;
            break;
        case 3:
            questionComponent = <Question4 nextQuestion={nextQuestion}/>;
            break;
        case 4:
            questionComponent = <Question5 nextQuestion={nextQuestion}/>;
            break;
        case 5:
            questionComponent = <Question6 nextQuestion={nextQuestion}/>;
            break;
        case 6:
            localStorage.setItem('finishedFeedback', true);
            window.$('.postresult').hide();
            break;
        case 7:
            nextQuestion(0);
            window.$('.postresult').hide();
            break;
        default:
            break;
    }


    return (
        <div className="feedback-container container">
            {questionComponent}
        </div>
    )
}

export default Feedback;
